import React, {
  useRef,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from 'react'

import * as d3 from 'd3'
import moment from 'moment'
import R from 'ramda'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { getFinalData } from 'marginanalysis/utils'

export default props => {
  const margin = 25
  const {
    whatIf = false,
    actualHeight = 170,
    actualWidth = 300,
    isEventPlanner = false,
  } = props

  const height = 180 - margin
  const width = actualWidth - margin

  const marginContext = useContext(MarginAnalysisContext)
  const { monthlyData = [] } = getFinalData(
    marginContext,
    whatIf,
    isEventPlanner
  )

  const graphData = useMemo(
    _ => {
      const md = monthlyData.map(d => ({
        year: parseInt(d.year),
        month: parseInt(d.month),
        monthyear: d.month + '' + d.year,
        date: moment(
          d.year + '' + (d.month.length === 1 ? '0' + d.month : d.month) + '15'
        ),
        caPercent: Number(parseFloat(d.caPercent).toFixed(2)),
      }))
      return R.sort((d1, d2) => (d2.date.isAfter(d1.date) ? 0 : 1), md)
    },
    [monthlyData]
  )

  const xScale = useMemo(
    _ =>
      d3
        .scaleBand()
        // .range([margin, width])
        .range([margin, width])
        .domain(graphData.map(d => d.date))
        .paddingInner(0)
        .padding(0),
    [graphData, width]
  )

  const yScale = useMemo(
    _ =>
      d3
        .scaleLinear()
        .range([height, 0])
        // .domain([margin, d3.max(graphData, (d) => d.caPercent)]);
        .domain([0, 100]),
    [height]
  )

  const svgRef = useRef()

  const drowBarChart = useCallback(
    _ => {
      const svg = d3.select(svgRef.current)
      if (svgRef.current) {
        // const selection = d3.selectAll("rect").data(graphData);
        // const g = d3.select("#dg");
        d3.selectAll('#xid').remove()
        d3.selectAll('#yid').remove()
        // d3.selectAll('#rid').remove()
        svg
          .append('g')
          .attr('id', 'xid')
          .attr('transform', 'translate(' + 0 + ',' + (height + margin) + ')')
          .call(d3.axisBottom(xScale).tickFormat(d => d.format('YY-MMM')))
          .selectAll('text')
          .attr('y', 0)
          .attr('x', 9)
          .attr('dy', '.35em')
          .attr('transform', 'rotate(45)')
          .attr('text-orientation', 'upright')
          .style('text-anchor', 'start')

        svg
          .append('g')
          .attr('id', 'yid')
          .attr('transform', 'translate(' + margin + ',' + margin + ')')
          .call(
            d3
              .axisLeft(yScale)
              .tickValues([0, 20, 40, 60, 80, 100])
              .tickFormat(d => d)
              // .tickSizeInner(150)
              .tickSize(1)
          )
      }
    },
    [height, xScale, yScale]
  )

  useEffect(_ => drowBarChart(), [drowBarChart, graphData])

  return (
    <div
      style={{
        height: actualHeight + 'px',
        border: '1px solid black',
      }}
    >
      <svg
        ref={svgRef}
        style={{
          height: actualHeight + 'px',
          width: actualWidth + 'px',
          margin: '10px',
        }}
      >
        <text x={10} y={yScale(100) + margin - 10}>
          Commercial Availability
        </text>
        <g id="dg" transform={'translate(' + margin + ',' + margin + ')'}>
          {graphData.map(d => (
            <g key={d.date} id="rid">
              <rect
                key={d.date}
                // date={d.date}
                // caPercent={d.caPercent}
                height={height - yScale(d.caPercent)}
                width={xScale.bandwidth() - 3}
                bandwidth={xScale.bandwidth() - 3}
                // x={xScale(d.date) - xScale.bandwidth() / 2}
                x={xScale(d.date) - margin}
                y={yScale(d.caPercent)}
                fill="#babad6"
                style={{ padding: '1px' }}
              />

              <text
                // x={xScale(d.date) - xScale.bandwidth() / 2 + 3}
                // y={yScale(d.caPercent - margin)}
                bd={xScale.bandwidth()}
                xv={xScale(d.date)}
                x={xScale(d.date) - margin + xScale.bandwidth() / 2 - 3 - 15}
                y={yScale(50)}
                writingMode1="tb"
                text-orientation1="upright"
                width="20px"
                style={{ textOrientation1: 'upright' }}
              >
                {isNaN(d.caPercent) ? 0 : d.caPercent}%
              </text>
            </g>
          ))}
        </g>
      </svg>
    </div>
  )
}
